// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--m1G7B","label":"a10a3f92e9--label--r1cQG","link":"a10a3f92e9--link--KrnMb","text":"a10a3f92e9--text--far2E"};